import { Injectable } from '@angular/core';
import { Http, QueryHandlerFor, Wrapper } from '@skylab-angular-shared/core';
import { BankAccountCollectionQuery, BankAccountCollectionQueryHandlerBase } from '@skylab-shared/business';

@Injectable({ providedIn: 'root'})
@QueryHandlerFor(BankAccountCollectionQuery)
@Wrapper(BankAccountCollectionQueryHandlerBase)
export class BankAccountQueryHandler {
    public constructor(
        http: Http
    ) { }
}
